import React from 'react';
import { Alert } from 'react-bootstrap';

function Wrapper() {
  return (
    <div className="d-flex flex-flow flex-column">
      <h5>Wrapper</h5>
      <Alert variant="warning">
        Wrapper can only be configured from POS Brazil.
      </Alert>
    </div>
  );
}

export default Wrapper;
